import { useTranslation } from "react-i18next";

export default function Prijzen() {
  const { t } = useTranslation("glas-vervangen");
  const rows = t("prijzen.rows", { returnObjects: true }) as Array<{
    dienst: string;
    prijs: string;
    tijd: string;
  }>;

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("prijzen.h2")}
        </h2>

        <div className="bg-white rounded-xl border border-brand-border overflow-hidden">
          {rows.map((row, i) => (
            <div
              key={i}
              className={`flex items-center justify-between gap-4 px-5 md:px-8 py-4 md:py-5 ${i !== 0 ? "border-t border-brand-border" : ""}`}
            >
              <div className="flex-1 min-w-0">
                <p className="font-geist text-sm md:text-base text-brand-text truncate">
                  {row.dienst}
                </p>
              </div>
              <div className="flex items-center gap-4 md:gap-8 flex-shrink-0">
                <span className="font-geist-mono font-bold text-base md:text-lg text-brand-text">
                  {row.prijs}
                </span>
                <span className="font-geist-mono text-xs md:text-sm text-brand-text/50 w-[70px] md:w-[80px] text-right">
                  {row.tijd}
                </span>
              </div>
            </div>
          ))}
        </div>

        <p className="font-geist text-sm text-brand-text/60 mt-5 md:mt-6 text-center">
          {t("prijzen.note")}
        </p>
      </div>
    </section>
  );
}